module.exports = __webpack_public_path__ + "static/media/serve1.5e4c0e60.png";